import styled from 'styled-components'
import { MEDIA_WIDTHS } from '../../../../themes'
import { TabsName } from '../../../../constants'

const Wrapper = styled.div`
  .course-tab-content {
    margin-bottom: 5px;
    border-radius: 8px;
    width: 100%;

    display: grid;
    --columns: 3;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: 16px;

    @media screen and (min-width: ${MEDIA_WIDTHS.upToVeryLager}px) {
      --columns: 4;
    }

    @media screen and (min-width: ${MEDIA_WIDTHS.upToBigLager}px) {
      --columns: 5;
    }

    @media screen and (min-width: ${MEDIA_WIDTHS.upToExtraLarge}px) {
      --columns: 6;
    }

    &.sidebar--close {
      grid-template-columns: repeat(var(--columns), 1fr);

      @media screen and (min-width: ${MEDIA_WIDTHS.upToMedium}px) {
        --columns: 4;
      }

      @media screen and (min-width: ${MEDIA_WIDTHS.upToVeryLager}px) {
        --columns: 5;
      }

      @media screen and (min-width: ${MEDIA_WIDTHS.upToBigLager}px) {
        --columns: 6;
      }

      @media screen and (min-width: ${MEDIA_WIDTHS.upToExtraLarge}px) {
        --columns: 7;
      }
    }
  }

  .course-empty {
    /* min-height: 240px; */
    min-height: clamp(12.188rem, -0.867rem + 16.13vw, 15rem);
    display: grid;
    place-content: center;
  }

  .justifyCenter {
    justify-content: center;
  }

  .course-tab {
    /* background: ${({ theme }) => theme.bg_cyan_white}; */

    .visible-class {
      visibility: hidden;
    }

    .header {
      padding-top: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /* background: ${({ theme }) => theme.bg_cyan_white}; */

      @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
      }

      .filter {
        color: ${({ theme }) => theme.text_primary};
        font-size: 14px;
        font-weight: 400;
        padding-bottom: 12px;

        display: flex;
        gap: 20px;

        @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
          margin-left: 10px;
        }
        .ant-checkbox-inner {
          width: 16px;
          height: 16px;
        }
      }
    }

    .body {
      padding: 4px 0 50px;

      @media screen and (min-width: 1170px) {
        width: calc(100vw - 320px - 16px);
      }

      &.sidebar--close {
        @media screen and (min-width: 1170px) {
          width: calc(100vw - 70px - 16px);
        }
      }
    }

    .tab-item {
      border: none;

      p {
        color: ${({ theme }) => theme.text_secondary};
        font-size: 20px;
        font-weight: 600;
      }

      &.active {
        background-color: transparent;
        p {
          color: ${({ theme }) => theme.text_active_green};
          font-weight: 600;
        }
      }
    }
  }

  .course-list {
    margin: 0 auto;
    padding: 0 35px;

    & + .course-list {
      margin-top: 8px;
    }
  }

  .course-list__title {
    padding: 4px 0;
    font-weight: bold;
    font-size: 20px;
    color: ${({ tab }) => (tab === TabsName.NISSOKEN_COURSE ? '#006ac0' : '#760076')};
    display: flex;
    align-items: center;
    gap: 15px;

    &::after {
      content: '';
      flex: 1;
      color: ${({ tab }) => (tab === TabsName.NISSOKEN_COURSE ? '#006ac0' : '#760076')};
      border-bottom: 2px solid;
    }
  }

  .course-list__title__icon {
    display: grid;
    place-items: center;
    font-size:20px;
  }

  .action-bottom {
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;

    p {
      cursor: pointer;
      text-align: right;
      text-decoration-line: underline;
      color: ${({ theme }) => theme.secondary};
    }
  }

  .ant-checkbox-inner {
    border: 1px solid #838383;
    border-radius: 5px;
  }

  .ant-checkbox-inner::after {
    background: #00c271;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background: #00c271;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner {
    border-color: #00c271;
  }

  .ant-pagination-item {
    border-color: #e2e2e2;
    border-radius: 2px;
    background-color: #fff;

    &:hover {
      border-color: ${({ theme }) => theme.text_active_green};
      background-color: #fff !important;
    }
  }

  .ant-pagination-item-active {
    border-color: ${({ theme }) => theme.text_active_green} !important;

    a {
      color: ${({ theme }) => theme.text_active_green};

      &:hover {
        color: ${({ theme }) => theme.text_active_green};
      }
    }
  }

  .ant-pagination-prev,
  .ant-pagination-next {
    .ant-pagination-item-link {
      border: 1px solid #e2e2e2;
      border-radius: 2px;
      background-color: #fff;

      &:hover {
        border-color: ${({ theme }) => theme.text_active_green};
        background-color: #fff !important;
      }
    }
  }
`
export default Wrapper
